import { createShopGateController } from './shopGateController.js';

/**
 * createShopInputWire — Live P-key / shop toggle gate (AR-08).
 * Closing is always allowed; opening goes through shopGate.
 */
export function createShopInputWire({ getMapId }) {
  const gate = createShopGateController({ getMapId });

  function onToggleShopAttempt(entity, { isOpen } = {}) {
    if (isOpen) return { ok: true };
    return gate.tryOpenShop(entity);
  }

  return { onToggleShopAttempt, canShop: gate.canShop };
}

/**
 * createShopToggleHandler — Binds shop UI + entity + HUD buttons (AR-08).
 * P is handled only by InputController (not KeybindingManager) to avoid double-toggle.
 */
export function createShopToggleHandler({
  getMapId,
  getEntity,
  shopUI,
  toggleBtn = null,
  closeBtn = null
}) {
  const wire = createShopInputWire({ getMapId });

  function tryToggleShop() {
    const result = wire.onToggleShopAttempt(getEntity(), { isOpen: shopUI.isOpen() });
    if (result.ok) shopUI.toggleShop();
    return result;
  }

  if (toggleBtn && typeof toggleBtn.addEventListener === 'function') {
    toggleBtn.addEventListener('click', () => tryToggleShop());
  }
  if (closeBtn && typeof closeBtn.addEventListener === 'function') {
    closeBtn.addEventListener('click', () => {
      if (shopUI.isOpen()) tryToggleShop();
    });
  }

  return { tryToggleShop };
}
